qw-input {
  display: flex;
  flex-flow: column;
  width: 100%;
}

qw-input .qw-input__label {
  margin-bottom: var(--qw-hotel-gap-sm);
}

qw-input input, qw-textarea textarea {
  appearance: none;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--qw-hotel-gap-sm);
  height: 100%;
  border: none;
  outline: 1px solid var(--qw-hotel-neutral-light);
}

qw-input .iti.iti--allow-dropdown {
  width: 100%;
}

qw-input input:focus, qw-textarea textarea {
  outline-offset: 0;
}

qw-input .qw-input__caption {
  font-size: 70%;
  margin-top: calc(var(--qw-hotel-gap-sm) / 2);
}

qw-input input[type="checkbox"] {
  width: 30px;
  height: 30px;
}

qw-input input[type="checkbox"]:checked {
  background: var(--qw-hotel-accent-color);
}
